import { useMutation, useQueryClient } from '@tanstack/react-query';
import { channelsApi } from '../services';

/**
 * Hook to activate a channel
 *
 * @returns React Query mutation result
 *
 * @example
 * const activateChannel = useActivateChannel();
 * activateChannel.mutate(channelId);
 */
export const useActivateChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => channelsApi.activate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['channels'] });
    },
  });
};
